export type ConfigVariants = string;

export enum IqConfigVariants {
	MORNINGSTAR_CATEGORIES = 'iq-morningstar-categories',
	AOF_DATA_CORRELATION = 'iq-aof-data-correlation'
}

export enum PaConfigVariants {
	CLIENT_PROPOSAL = 'client-proposal',
}

export enum SharedConfigVariants {
	STATUS = 'fund-analysis-status',
	BLK_FUND_IDEAS = 'blk-fund-ideas',
}

export enum MeConfigVariants {
	PERFORMANCE_AS_OF_DATE = 'models-experience-as-of-date',
}
